(function() {
  var SppHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SppHandler = App.loadClass('grower::handlers/placement/SppHandler');

  exports.RuppGoodYieldsHandler = (function(superClass) {
    extend(RuppGoodYieldsHandler, superClass);

    function RuppGoodYieldsHandler() {
      this.customPlantingPlan = bind(this.customPlantingPlan, this);
      return RuppGoodYieldsHandler.__super__.constructor.apply(this, arguments);
    }

    RuppGoodYieldsHandler.prototype.init = function() {
      this.customButtons = [
        {
          'html': '<button class="btn btn-primary pull-left" id="pdf_button" data-loading-text="Generating report..." > <i class="fa fa-file-o"></i> Summary Report </button>',
          'click': (function(_this) {
            return function() {
              var layers;
              layers = _this.curStep.stepKO.plantingPlans();
              return _this.actionPdf(layers);
            };
          })(this)
        }, {
          'html': '<button class="btn btn-blue pull-right"> <i class="fa fa-chevron-right"></i> Place Order </button>',
          'click': (function(_this) {
            return function() {
              var hybrid_list, i, len, order, ref, v;
              hybrid_list = [];
              ref = _this.curStep.selectionsKO.hybrids();
              for (i = 0, len = ref.length; i < len; i++) {
                v = ref[i];
                hybrid_list.push({
                  hybrids_id: v.id,
                  treatments_id: v.treatmentID,
                  qty: v.units
                });
              }
              order = _this.curStep.createSubHandler('grower::handlers/rupp_orders/RuppOrdersDialogHandler');
              if (order) {
                order.saveData = {
                  crops_id: _this.cropID,
                  lines: hybrid_list
                };
                order.loadLayoutPostOptions = {
                  'crops_id': _this.cropID
                };
                order.init();
                return App.sidebar.close();
              }
            };
          })(this)
        }
      ];
      return RuppGoodYieldsHandler.__super__.init.call(this);
    };

    RuppGoodYieldsHandler.prototype.customPlantingPlan = function(field_id, plan, notes_obj) {
      var notesFn, products;
      products = this.taffyObjects.hybrids;
      this._customProductSubscription = function(stage, product_id) {
        var product;
        product = products({
          id: parseInt(product_id)
        }).first();
        stage.treatment = product != null ? product.default_treatment_id : void 0;
        return notesFn();
      };
      return notesFn = function() {
        var event, i, j, len, len1, notes, product, ref, ref1, ref2, stage;
        notes = '';
        ref = plan.events;
        for (i = 0, len = ref.length; i < len; i++) {
          event = ref[i];
          ref1 = event.stages;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            stage = ref1[j];
            product = products({
              id: parseInt((ref2 = stage.product) != null ? ref2.id : void 0)
            }).first();
            if (!product || !product.description) {
              continue;
            }
            notes += product.display_name;
            notes += '<br>';
            if (product.description) {
              notes += product.description + '<br/>';
            }
          }
        }
        return notes_obj.notes = notes;
      };
    };

    return RuppGoodYieldsHandler;

  })(SppHandler);

}).call(this);
